import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  closeOrder,
  completeImage,
  completeOrder,
  openOrder,
} from '../../assets/icons';
import { getAllOffersForMediator } from '../../services/apis/offer';
import { getOrdersStatusStatisticsMediators } from '../../services/apis/order';
import Environment from '../../services/Environment';
import { get } from '../../services/Request';
import { CardSkeleton } from '../index';
import { userToken } from '../../helpers/helper';

const MDashboardCard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [statistics, setStatistics] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if(userToken){
      getStatisticsOrderMediators();
    }
    
  }, []);

  const getStatisticsOrderMediators = async () => {
    setLoading(true);
    const response = await getOrdersStatusStatisticsMediators('');
    setStatistics(response.data, setLoading(false));
  };
  return (
    <>
      {loading ? (
        <div className="grid 2xl:grid-cols-4 xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-1 gap-x-4 w-[80%] mr-auto ml-auto mt-10">
          <CardSkeleton number={4} height={'300px'} />
        </div>
      ) : (
        <div className="grid 2xl:grid-cols-4 xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-x-4 w-[80%] mr-auto ml-auto mt-10">
          <div
            className="flex flex-col justify-between bg-[#BBF7F1] rounded-[15px] p-5 max600:mt-5 max600:order-3 sm:mt-3 cursor-pointer">
            <div className="flex items-center justify-center">
              <img src={completeOrder} />
            </div>
            <div className="flex items-center justify-center bg-[#ffffff] rounded-[15px]">
              <div className="text-[#444444] text-[15px] font-700">
                {t('home.orders.accept')}
              </div>
              <div className="text-[#00CEBC] text-[35px] font-700 mx-5">
                {statistics?.offersStatusStatistics?.countOfAcceptedOffers}
              </div>
            </div>
          </div>
          <div
            className="flex flex-col justify-between bg-[#FEBFBF] rounded-[15px] p-5 max600:mt-5 max600:order-2 sm:mt-3 cursor-pointer">
            <div className="flex items-center justify-center">
              <img src={closeOrder} />
            </div>
            <div className="flex items-center justify-center bg-[#FFFFFF] rounded-[15px]">
              <div className="text-[#444444] text-[15px] font-700">
                {t('home.orders.reject')}
              </div>
              <div className="text-[#FD2828] text-[35px] font-700 mx-5">
                {statistics?.offersStatusStatistics?.countOfRejectedOffers}
              </div>
            </div>
          </div>
          <div
            className="flex flex-col justify-between bg-[#D7E2FF] rounded-[15px] p-5 max600:mt-5 max600:order-1 sm:mt-3 cursor-pointer">
            <div className="flex items-center justify-center">
              <img src={openOrder} />
            </div>
            <div className="flex items-center justify-center bg-[#FFFFFF] rounded-[15px]">
              <div className="text-[#444444] text-[15px] font-700">
                {t('home.orders.pending')}
              </div>
              <div className="text-[#3E0292] text-[35px] font-700 mx-5">
                {statistics?.offersStatusStatistics?.countOfPendingOffers}
              </div>
            </div>
          </div>
          <div
            className="flex flex-col justify-between bg-[#9FBDFF] rounded-[15px] p-5 max600:mt-5 max600:order-1 sm:mt-3 cursor-pointer">
            <div className="flex items-center justify-center">
              <img src={completeImage} />
            </div>
            <div className="flex items-center justify-center bg-[#FFFFFF] rounded-[15px]">
              <div className="text-[#444444] text-[15px] font-700">
                {t('home.orders.complete')}
              </div>
              <div className="text-[#407BFF] text-[35px] font-700 mx-5">
                {statistics?.offersStatusStatistics?.countOfCompletedOffers}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MDashboardCard;
